function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var SaitoNFT = require('../../../lib/saito/ui/saito-nft/saito-nft');
var _require = require('saito-js/lib/slip'),
  SlipType = _require.SlipType;
var _require2 = require('./archive'),
  loadTransactionFromArchive = _require2.loadTransactionFromArchive;
var DREAMSCAPE_PLACEHOLDER = '/saito/img/dreamscape.png';
function tryLoadImageUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new Promise(function (resolve) {
    if (!url || typeof Image === 'undefined') {
      resolve(false);
      return;
    }
    var img = new Image();
    img.onload = function () {
      return resolve(true);
    };
    img.onerror = function () {
      return resolve(false);
    };
    img.src = url;
  });
}
function applyListingTransaction(summary, tx) {
  var _listing$description;
  if (!summary || !tx) {
    return summary;
  }
  summary.listing_tx = tx;
  if (tx.signature) {
    summary.listing_signature = tx.signature;
  }
  var txmsg = typeof tx.returnMessage === 'function' ? tx.returnMessage() : {};
  var listing = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.listing) || {};
  var title = String(listing.title || txmsg.title || '').trim();
  if (title && !String(summary.title || '').trim()) {
    summary.title = title;
  }
  var description = (_listing$description = listing.description) !== null && _listing$description !== void 0 ? _listing$description : txmsg.description;
  if (description != null && description !== '' && !summary.description) {
    summary.description = String(description);
  }
  if (!summary.seller) {
    var _tx$from, _tx$from2;
    // Bound from[0] is mint creator metadata; ownership is Normal/ATR from[1].
    var from0 = (_tx$from = tx.from) === null || _tx$from === void 0 ? void 0 : _tx$from[0];
    var from1 = (_tx$from2 = tx.from) === null || _tx$from2 === void 0 ? void 0 : _tx$from2[1];
    var seller = (from0 === null || from0 === void 0 ? void 0 : from0.publicKey) || '';
    if ((from0 === null || from0 === void 0 ? void 0 : from0.type) === SlipType.Bound && from1 !== null && from1 !== void 0 && from1.publicKey) {
      seller = from1.publicKey;
    }
    if (seller) {
      summary.seller = seller;
    }
  }
  var web3Ticker = String(listing.web3_ticker || '').trim().toUpperCase();
  if (web3Ticker) {
    summary.web3_ticker = web3Ticker;
  }
  if (listing.web3_amount != null && String(listing.web3_amount) !== '') {
    summary.web3_amount = String(listing.web3_amount).trim();
  }
  if (web3Ticker && web3Ticker !== 'SAITO') {
    // Crypto amount stays on web3_amount. Do not store it as SAITO nolan.
  } else if (!Number(summary.price)) {
    var _listing$price;
    var raw_price = (_listing$price = listing.price) !== null && _listing$price !== void 0 ? _listing$price : txmsg.price;
    if (raw_price != null && raw_price !== '') {
      var _ref, _summary$app$wallet$c, _summary$app, _summary$app$convertS;
      var converted = Number((_ref = (_summary$app$wallet$c = (_summary$app = summary.app) === null || _summary$app === void 0 || (_summary$app = _summary$app.wallet) === null || _summary$app === void 0 || (_summary$app$convertS = _summary$app.convertSaitoToNolan) === null || _summary$app$convertS === void 0 ? void 0 : _summary$app$convertS.call(_summary$app, raw_price)) !== null && _summary$app$wallet$c !== void 0 ? _summary$app$wallet$c : raw_price) !== null && _ref !== void 0 ? _ref : 0);
      if (Number.isFinite(converted) && converted > 0) {
        summary.price = converted;
      }
    }
  }
  try {
    var _nft$returnImage;
    var nft = new SaitoNFT(summary.app, summary.mod, tx, null);
    summary.nft = nft;
    if (!String(summary.title || '').trim() && nft.title) {
      summary.title = nft.title;
    }
    var image = ((_nft$returnImage = nft.returnImage) === null || _nft$returnImage === void 0 ? void 0 : _nft$returnImage.call(nft)) || '';
    if (image) {
      summary.image = image;
    }
  } catch (err) {
    console.warn('Store: applyListingTransaction NFT parse failed', (err === null || err === void 0 ? void 0 : err.message) || err);
  }
  return summary;
}
function notifySummaryUpdated(summary) {
  var _summary$app2;
  if (summary !== null && summary !== void 0 && (_summary$app2 = summary.app) !== null && _summary$app2 !== void 0 && _summary$app2.connection) {
    summary.app.connection.emit('store-listing-updated', summary);
  }
}
function ensureListingTransaction(_x) {
  return _ensureListingTransaction.apply(this, arguments);
}
function _ensureListingTransaction() {
  _ensureListingTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(summary) {
    var signature;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(!summary || summary.listing_tx)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, summary);
        case 1:
          if (!summary._listing_tx_promise) {
            _context.n = 2;
            break;
          }
          return _context.a(2, summary._listing_tx_promise);
        case 2:
          signature = summary.listing_signature || '';
          if (signature) {
            _context.n = 3;
            break;
          }
          return _context.a(2, summary);
        case 3:
          summary._listing_tx_promise = loadTransactionFromArchive(summary.app, signature).then(function (tx) {
            if (tx) {
              applyListingTransaction(summary, tx);
            }
            return summary;
          });
          return _context.a(2, summary._listing_tx_promise);
      }
    }, _callee);
  }));
  return _ensureListingTransaction.apply(this, arguments);
}
function enrichSummaryMedia(_x2) {
  return _enrichSummaryMedia.apply(this, arguments);
}
function _enrichSummaryMedia() {
  _enrichSummaryMedia = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(summary) {
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          if (!(!summary || summary.image)) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2, summary);
        case 1:
          if (!summary._media_enrich_promise) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, summary._media_enrich_promise);
        case 2:
          summary._media_enrich_promise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
            var _summary$returnCacheI;
            var cache_url, ok;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  cache_url = ((_summary$returnCacheI = summary.returnCacheImageUrl) === null || _summary$returnCacheI === void 0 ? void 0 : _summary$returnCacheI.call(summary)) || '';
                  if (!cache_url) {
                    _context2.n = 2;
                    break;
                  }
                  _context2.n = 1;
                  return tryLoadImageUrl(cache_url);
                case 1:
                  ok = _context2.v;
                  if (!ok) {
                    _context2.n = 2;
                    break;
                  }
                  summary.image = cache_url;
                  summary._image_source = 'store-cache';
                  notifySummaryUpdated(summary);
                  return _context2.a(2, summary);
                case 2:
                  _context2.n = 3;
                  return ensureListingTransaction(summary);
                case 3:
                  if (summary.image) {
                    summary._image_source = 'archive';
                  }
                  summary._media_enriched = true;
                  notifySummaryUpdated(summary);
                  return _context2.a(2, summary);
              }
            }, _callee2);
          }))();
          return _context3.a(2, summary._media_enrich_promise);
      }
    }, _callee3);
  }));
  return _enrichSummaryMedia.apply(this, arguments);
}
module.exports = {
  DREAMSCAPE_PLACEHOLDER: DREAMSCAPE_PLACEHOLDER,
  tryLoadImageUrl: tryLoadImageUrl,
  applyListingTransaction: applyListingTransaction,
  ensureListingTransaction: ensureListingTransaction,
  enrichSummaryMedia: enrichSummaryMedia,
  notifySummaryUpdated: notifySummaryUpdated
};